export const absoluteToRelativeUrl = absoluteUrl =>
  absoluteUrl ? new URL(absoluteUrl).pathname : null
